import React from 'react'
import HomeLayout from 'apps/HomeLayout'
import NoAvailablePrinterForm from 'apps/NoAvailablePrinterForm'

const NoAvailablePrinter: React.FC<{}> = () => (
  <HomeLayout>
    <NoAvailablePrinterForm />
  </HomeLayout>
)

export default NoAvailablePrinter
